import type { SponsorPlanItem } from '@app/_proto/Protos/sponsors';
import type { SubscriptionItem } from '@app/_proto/Protos/subscriptions';
import ChampionPlans from '@app/domains/champion/components/ChampionPlans';

type Props = {
    on?: string;
    novelId: number;
    novelName: string;
    championPlans: SponsorPlanItem[];
    activeChampionSubscription: SubscriptionItem | undefined;
    onSubscribePlan: () => void;
};

export default function ChampionAllPlansDialogPanel({
    novelId,
    novelName,
    championPlans,
    activeChampionSubscription,
    onSubscribePlan,
}: Props) {
    return (
        <div>
            <div className="mb-4 text-center md:mb-[4.5px]">
                <img className="inline-block w-140 md:w-176" src="/images/champion-logo@3x.png" alt="champion-logo" />
            </div>
            <div className="mb-15 text-center md:mb-20">
                <h2 className="font-set-b26 text-gray-t1">{novelName}</h2>
            </div>
            <div className="mb-8 text-center md:mb-12">
                <p className="font-set-sb16 text-gray-t3 md:font-set-sb18">All Champion Tiers</p>
            </div>
            <ChampionPlans
                novelId={novelId}
                sponsorPlans={championPlans}
                currentSubscription={activeChampionSubscription ?? null}
                onSelectPlan={onSubscribePlan}
                gapX={12}
                gapY={12}
                maxColumn={2}
            />
        </div>
    );
}
